/**
 * ICE cars the driver can pick in Drive setup: approximate road speed (km/h) at the rev limiter in each gear.
 * ONLY ordinary cars (Marc: the app is for cars that do NOT already sound good — no BMW, Mercedes, Porsche,
 * Ferrari…). The virtual gearbox shifts where the real car does, so the Porsche engine follows your own gears.
 * Values are typical figures for the common petrol/diesel manual versions, rounded — drivers can edit them.
 */
export interface IceCar {
  id: string;
  brand: string;
  model: string;
  gears: number[];
}

export const ICE_CARS: IceCar[] = [
  { id: 'citroen-c3', brand: 'Citroën', model: 'C3 1.2 PureTech', gears: [42, 78, 118, 155, 190] },
  { id: 'citroen-c4', brand: 'Citroën', model: 'C4 1.2 PureTech', gears: [45, 82, 125, 165, 205, 210] },
  { id: 'dacia-sandero', brand: 'Dacia', model: 'Sandero 1.0 TCe', gears: [42, 78, 118, 155, 175] },
  { id: 'dacia-duster', brand: 'Dacia', model: 'Duster 1.3 TCe', gears: [45, 82, 125, 165, 190, 195] },
  { id: 'fiat-500', brand: 'Fiat', model: '500 1.0 Hybrid', gears: [38, 68, 100, 135, 165, 167] },
  { id: 'fiat-panda', brand: 'Fiat', model: 'Panda 1.0 Hybrid', gears: [38, 68, 100, 135, 160, 164] },
  { id: 'fiat-tipo', brand: 'Fiat', model: 'Tipo 1.0', gears: [45, 82, 125, 165, 200, 205] },
  { id: 'ford-fiesta', brand: 'Ford', model: 'Fiesta 1.0 EcoBoost', gears: [45, 80, 120, 160, 195, 200] },
  { id: 'ford-focus', brand: 'Ford', model: 'Focus 1.0 EcoBoost', gears: [45, 82, 125, 165, 205, 210] },
  { id: 'ford-puma', brand: 'Ford', model: 'Puma 1.0 EcoBoost', gears: [45, 80, 122, 162, 200, 205] },
  { id: 'honda-jazz', brand: 'Honda', model: 'Jazz 1.3', gears: [45, 80, 120, 160, 190] },
  { id: 'honda-civic-1-0', brand: 'Honda', model: 'Civic 1.0 VTEC Turbo', gears: [48, 85, 128, 170, 210, 215] },
  { id: 'hyundai-i10', brand: 'Hyundai', model: 'i10 1.0', gears: [38, 68, 100, 135, 160] },
  { id: 'hyundai-i20', brand: 'Hyundai', model: 'i20 1.0 T-GDi', gears: [45, 80, 120, 160, 190, 195] },
  { id: 'hyundai-i30', brand: 'Hyundai', model: 'i30 1.0 T-GDi', gears: [45, 82, 125, 165, 200, 205] },
  { id: 'kia-picanto', brand: 'Kia', model: 'Picanto 1.0', gears: [38, 68, 100, 135, 160] },
  { id: 'kia-ceed', brand: 'Kia', model: 'Ceed 1.0 T-GDi', gears: [45, 82, 125, 165, 200, 205] },
  { id: 'mazda-2', brand: 'Mazda', model: 'Mazda2 1.5', gears: [45, 80, 120, 160, 195, 200] },
  { id: 'mazda-3', brand: 'Mazda', model: 'Mazda3 2.0', gears: [50, 88, 130, 170, 205, 210] },
  { id: 'mg-3', brand: 'MG', model: 'MG3 1.5', gears: [45, 80, 120, 160, 180] },
  { id: 'nissan-micra', brand: 'Nissan', model: 'Micra 1.0 IG-T', gears: [42, 76, 115, 152, 185] },
  { id: 'nissan-qashqai', brand: 'Nissan', model: 'Qashqai 1.3 DIG-T', gears: [45, 82, 125, 165, 200, 205] },
  { id: 'opel-corsa', brand: 'Opel', model: 'Corsa 1.2', gears: [42, 78, 118, 155, 190, 195] },
  { id: 'opel-astra', brand: 'Opel', model: 'Astra 1.2', gears: [45, 82, 125, 165, 205, 210] },
  { id: 'peugeot-208', brand: 'Peugeot', model: '208 1.2 PureTech', gears: [42, 78, 118, 155, 190, 195] },
  { id: 'peugeot-308', brand: 'Peugeot', model: '308 1.2 PureTech', gears: [45, 82, 125, 165, 205, 210] },
  { id: 'renault-clio', brand: 'Renault', model: 'Clio 1.0 TCe', gears: [42, 78, 118, 155, 185, 190] },
  { id: 'renault-captur', brand: 'Renault', model: 'Captur 1.3 TCe', gears: [45, 82, 125, 165, 195, 200] },
  { id: 'renault-megane', brand: 'Renault', model: 'Mégane 1.3 TCe', gears: [45, 82, 125, 165, 205, 210] },
  { id: 'seat-ibiza', brand: 'SEAT', model: 'Ibiza 1.0 TSI', gears: [45, 80, 120, 160, 195, 200] },
  { id: 'seat-leon', brand: 'SEAT', model: 'Leon 1.5 TSI', gears: [48, 85, 128, 170, 210, 220] },
  { id: 'seat-arona', brand: 'SEAT', model: 'Arona 1.0 TSI', gears: [45, 80, 120, 160, 190, 195] },
  { id: 'skoda-fabia', brand: 'Škoda', model: 'Fabia 1.0 TSI', gears: [45, 80, 120, 160, 195, 200] },
  { id: 'skoda-octavia', brand: 'Škoda', model: 'Octavia 1.5 TSI', gears: [48, 85, 128, 170, 210, 225] },
  { id: 'suzuki-swift', brand: 'Suzuki', model: 'Swift 1.2', gears: [42, 76, 115, 152, 180] },
  { id: 'toyota-aygo', brand: 'Toyota', model: 'Aygo X 1.0', gears: [38, 68, 100, 135, 158] },
  { id: 'toyota-yaris-1-5', brand: 'Toyota', model: 'Yaris 1.5 (manual)', gears: [45, 80, 120, 160, 175, 180] },
  { id: 'toyota-corolla-1-2', brand: 'Toyota', model: 'Corolla 1.2 Turbo', gears: [45, 82, 125, 165, 200, 205] },
  { id: 'vw-up', brand: 'Volkswagen', model: 'up! 1.0', gears: [38, 68, 100, 135, 165] },
  { id: 'vw-polo', brand: 'Volkswagen', model: 'Polo 1.0 TSI', gears: [45, 80, 120, 160, 195, 200] },
  { id: 'vw-golf-1-5', brand: 'Volkswagen', model: 'Golf 1.5 TSI', gears: [48, 85, 128, 170, 210, 225] },
  { id: 'vw-tcross', brand: 'Volkswagen', model: 'T-Cross 1.0 TSI', gears: [45, 80, 120, 160, 190, 195] },
];

export const ICE_BRANDS: string[] = [...new Set(ICE_CARS.map((c) => c.brand))].sort((a, b) => a.localeCompare(b));

/** The ceiling is the Porsche itself (911 GT3 Cup ladder, km/h at the limiter): no gear may run past what the engine can do. */
export const PORSCHE_LADDER_KMH = [92, 132, 170, 208, 246, 285];
/** Plausible road speed at the limiter per gear (km/h): floor = a small city car, ceiling = the Porsche's gear (285 beyond 6th). */
export const GEAR_LIMITS_KMH: [number, number][] = [
  [30, PORSCHE_LADDER_KMH[0]], [55, PORSCHE_LADDER_KMH[1]], [85, PORSCHE_LADDER_KMH[2]], [110, PORSCHE_LADDER_KMH[3]],
  [130, PORSCHE_LADDER_KMH[4]], [150, PORSCHE_LADDER_KMH[5]], [160, 285], [170, 285],
];

/** Why a typed gear list is rejected, in the driver's words — null when it is fine. */
export function gearTopsProblem(raw: unknown): string | null {
  if (!Array.isArray(raw)) return 'no gears';
  if (raw.length < 3 || raw.length > 8) return '3 to 8 gears';
  const nums = raw.map((v) => Number(v));
  for (let i = 0; i < nums.length; i++) {
    const v = nums[i];
    if (!Number.isFinite(v)) return `gear ${i + 1}: enter a speed`;
    const [lo, hi] = GEAR_LIMITS_KMH[i];
    if (v < lo || v > hi) return `gear ${i + 1}: between ${lo} and ${hi} km/h (the engine's limit)`;
    if (i > 0 && v < nums[i - 1] + 2) return `gear ${i + 1}: faster than gear ${i}`;
    if (i > 0 && v > nums[i - 1] * 1.9) return `gear ${i + 1}: too big a jump from gear ${i}`;
  }
  return null;
}

/** Sanitise a per-gear speed list typed by the driver (see GEAR_LIMITS_KMH). Returns null when unusable. */
export function cleanGearTops(raw: unknown): number[] | null {
  if (gearTopsProblem(raw)) return null;
  return (raw as unknown[]).map((v) => Math.round(Number(v)));
}
